export class EmptyTemplateEngine {
    static create(behavior, componentOptions) {
        return new EmptyTemplateEngine(componentOptions.externalComponent);
    }
    // eslint-disable-next-line no-useless-constructor
    constructor(externalComponent) {
        this.externalComponent = externalComponent;
        //
    }
    createInstance(comp, createShadowRoot) {
        const instance = {
            shadowRoot: this.externalComponent
                ? {
                    root: comp.getBackendElement(),
                    slot: comp.getBackendElement(),
                    getIdMap: () => ({}),
                    handleEvent: () => {
                        // empty
                    },
                    setListener: () => {
                        // empty
                    },
                }
                : createShadowRoot(comp),
            initValues: (_data) => {
                // empty
            },
            updateValues: (_data, _changes) => {
                // empty
            },
        };
        return instance;
    }
}
//# sourceMappingURL=template_engine.js.map